module.exports = __webpack_public_path__ + "img/codeImg.d3f437c7.jpg";